<template>
  <div>
    <div v-if="collectionOfData.length != 0 && !config.hideCollection">
      <div
        style="width: 100%"
        v-for="(document, index) in collectionOfData"
        :key="index + '_afd'"
        class="mb-2"
      >
        <div v-if="document != null">
          <span class="borderStyle">
            <span class="file-icon">📄</span>
            <span class="spanStyle">{{ document.name }}</span>
            <button
              class="closeButton"
              @click="deleteFile(document)"
              title="Remove file"
            >
              ×
            </button>
          </span>
          <br />
        </div>
      </div>
    </div>
    <div :class="config.marginStyle">
      <button
        :class="config.btnClass || 'attach-files-btn'"
        @click="showAttachFileDetails"
        :disabled="isProcessing || isDisabled(config)"
      >
        {{ config.label || 'Attach Files' }}
      </button>
      <div v-if="config.required && isInvalid" class="error_message">
        {{ config.requiredMessage }}
      </div>
    </div>
    <div v-if="showAttachFileModel" class="modal-overlay">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ config.attachFileLabel || 'Attach Files' }}</h3>
            <button class="modal-close-btn" @click="backToRequest">×</button>
          </div>
          <div class="model-text">Attach a document from the box folder or upload a file from your local machine (optional)</div>
          <div class="modal-body">
            <div class="tabs-container">
              <div class="tabs-header">
                <button 
                  :class="['tab-btn', { active: selectedTab === 'link' }]"
                  @click="selectedTab = 'link'"
                >
                  LINK FROM BOX FOLDER
                </button>
                <button 
                  :class="['tab-btn', { active: selectedTab === 'upload' }]"
                  @click="selectedTab = 'upload'"
                >
                  UPLOAD FROM LOCAL MACHINE
                </button>
              </div>
              
              <div class="tab-content">
                <div v-if="selectedTab === 'link'" class="tab-panel">
                  <BoxComponent
                    ref="boxComponent"
                    :assignmentData="assignmentData"
                    :allowedExtensions="[]"
                    :isValid="true"
                    :subFolder="subFolder"
                    :copyBoxFileToAccounting="config.copyBoxFileToAccounting"
                    @boxObject="getBoxObject"
                    @closeModal="attachToRequest"
                  />
                </div>
                
                <div v-if="selectedTab === 'upload'" class="tab-panel">
                  <BoxUploadComponent
                    ref="boxUploadComponent"
                    :assignmentData="assignmentData"
                    :subFolder="subFolder"
                    :isValid="isValid"
                    :disableAutoClose="config.disableAutoClose || true"
                    :allowedExtensions="config.allowedExtensions"
                    @boxObject="getBoxObject"
                    @processing="setProcessing"
                    @closeModal="attachToRequest"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BoxComponent from './BoxComponent.vue'
import BoxUploadComponent from './BoxUploadComponent.vue'
import { getBoxToken } from '@/service/engagement.js'
import { getWorkfileId } from '@/utils/globalUtil'
import { mapActions } from 'vuex'

export default {
  name: 'AttachFileDetails',
  components: {
    BoxComponent,
    BoxUploadComponent,
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    assignmentData: {
      type: Object,
    },
    itemData: {
      type: Object,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    preservedFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showAttachFileModel: false,
      documents: [],
      collectionOfData: [],
      isProcessing: false,
      subFolder: null,
      selectedTab: 'link',
      showLoader: false,
    }
  },
  computed: {
    isInvalid() {
      if (this.validator) {
        if (this.validator.hasOwnProperty(this.config.errorFieldId)) {
          return !this.validator[this.config.errorFieldId]
        }
      }
      return false
    },
    isValid() {
      return !this.isInvalid
    },
  },
  methods: {
    ...mapActions({
      add: "notification/add",
    }),
    
    async backToRequest() {
      if (this.config.id === 'preReviewScrub') {
        this.collectionOfData.splice(0)
      }
      this.showAttachFileModel = false
    },
    
    attachToRequest() {
      this.showAttachFileModel = false
    },
    
    toPostUploadFiles() {
      this.$emit('collections', this.collectionOfData)
      this.setProcessing(false)
      if (!this.config.disableAutoCloseDialog) {
        this.showAttachFileModel = false
      }
    },
    
    async showAttachFileDetails() {
      if (
        this.config.id === 'preReviewScrub' &&
        !this.config.createBoxFolderOnMounted
      ) {
        await this.getBoxSubFolder()
      }

      this.showAttachFileModel = true
    },
    
    getBoxObject(value) {
      this.boxInfo = [...value]
      this.boxInfo.map((item) => {
        let _doc = this.itemExistsByName(item.name)
        if (!_doc) {
          this.collectionOfData.push({
            id: item.id,
            name: item.name,
            size: item.size,
            folderId: item.folderId,
            created_at: item.created_at,
            modified_by: item.modified_by,
            _file: item._file // In case we need the file object
          })
        }
      })
      this.toPostUploadFiles()
      if (this.config.clearCollection) {
        this.collectionOfData.splice(0)
      }
    },
    
    deleteFile(document) {
      for (let i = 0; i < this.collectionOfData.length; i++) {
        if (this.collectionOfData[i].name === document.name) {
          this.collectionOfData.splice(i, 1)
          break
        }
      }
      this.$emit('collections', this.collectionOfData)
    },
    
    itemExistsByName(fileName) {
      return this.collectionOfData.find((x) => x.name == fileName)
    },
    
    setProcessing(isProcessing) {
      this.isProcessing = isProcessing
    },
    
    getBoxSubFolder() {
      let workfile = this.assignmentData?.workFileLink
      let folderId = getWorkfileId(workfile)
      if (folderId) {
        // Set the subFolder based on config or use the folder ID
        this.subFolder = this.config.subFolder || folderId
      }
    },
    
    isDisabled(config) {
      if (config.isDisabled) {
        return config.isDisabled
      }
      // Add additional disable logic as needed
      return false
    },
  },
  
  mounted() {
    this.getBoxSubFolder()
    
    if (this.preservedFiles && this.preservedFiles.length > 0) {
      this.collectionOfData = [...this.preservedFiles]
      this.toPostUploadFiles()
      return
    }
    
    // Handle existing files from itemData if available
    if (
      this.itemData &&
      this.itemData.documentForReview &&
      this.itemData.documentForReview.length > 0
    ) {
      this.collectionOfData.push(...this.itemData.documentForReview)
      this.toPostUploadFiles()
    }
  },
  
  watch: {
    preservedFiles: {
      handler(newFiles) {
        if (newFiles && newFiles.length > 0) {
          this.collectionOfData = [...newFiles]
        } else if (newFiles && newFiles.length === 0) {
          this.collectionOfData = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style scoped>
.floatRight {
  float: right;
}

.borderStyle {
  border: 1px solid #e0e0e0;
  width: auto;
  padding: 8px 12px;
  line-height: 20px;
  border-radius: 4px;
  display: inline-block;
  background-color: #f8f9fa;
  margin-bottom: 8px;
  position: relative;
  padding-right: 32px; /* Add space for the button */
}

.closeButton {
  background: #666;
  border: 1px solid #999;
  border-radius: 50%;
  color: white;
  width: 20px;
  height: 20px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  position: absolute;
  top: 15px;
  right: 4px;
  margin: 0; 
  display: grid
}

.closeButton:hover {
  background: #333;
}

.spanStyle {
  display: inline-block;
  word-break: break-all;
  margin-left: 28px;
  margin-right: 8px;
  max-width: calc(100% - 60px);
}

.error_message {
  color: #ff5252;
  max-height: 30px;
  font-size: 12px;
  margin: 8px;
}

.file-icon {
  color: #666;
  vertical-align: top;
  margin-right: 4px;
  position: absolute;
  top: 8px;
  left: 8px;
}

.attach-files-btn {
  padding: 10px 16px;
  border: 1px solid #003F2D;
  border-radius: 4px;
  background-color: transparent;
  color: #003F2D;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.attach-files-btn:hover {
  border-color: #333;
  background-color: #f8f9fa;
}

.attach-files-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mb-2 {
  margin-bottom: 8px;
}

.mb-4 {
  margin-bottom: 16px;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-dialog {
  width: 98%;
  max-width: 800px;
  max-height: 80vh;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
}

.modal-header {
  padding: 6px 8px 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center; /* Center vertically */
  gap: 0;
}

.modal-title {
  margin: 0;
  margin-top: 5px;
  font-size: 16px;
  font-weight: 500;
  color: #003F2D;
  font-family: Calibre-R;
  font-style: Medium;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  flex: 0 1 auto;
  text-align: left;
  display: block;
  align-items: center;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding-top: 1px; /* Optical tweak for centering */
  transition: background 0.2s;
  line-height: 1;
}

.modal-close-btn:hover {
  background-color: #f0f0f0;
}

.modal-body {
  padding: 8px 2px;
  flex: 1;
  overflow-y: auto;
  max-height: 100%;
  box-sizing: border-box;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Tabs styles */
.tabs-container {
  width: 100%;
}

.tabs-header {
  display: flex;
  border-bottom: 2.5px solid #e0e0e0;
  margin-bottom: 20px;
  background: #fff;
  align-items: flex-end;
}

.tab-btn {
  flex: 1;
  padding: 12px 0;
  border: none;
  background: none;
  font-size: 15px;
  font-weight: 500;
  color: #5A5A5A;
  cursor: pointer;
  border-bottom: 4px solid transparent;
  transition: color 0.2s, border-bottom-color 0.2s;
  text-align: center;
  letter-spacing: 0.5px;
  white-space: normal;
  line-height: 1.2;
  min-height: unset;
}

.tab-btn:hover {
  background-color: #f8f9fa;
}

.tab-btn.active {
  color: #003F2D; /* Dark green */
  border-bottom: 4px solid #003F2D;
  font-weight: 600;
  font-size: 15px;
  background: #fff;
}

.tab-content {
  /* min-height: 300px; */
}

.tab-panel {
  padding: 20px 0;
}

/* Button styles */
.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid;
  transition: all 0.2s ease;
  font-family: inherit;
}

.btn-secondary {
  background-color: #f8f9fa;
  border-color: #6c757d;
  color: #6c757d;
}

.btn-secondary:hover {
  background-color: #e9ecef;
  border-color: #5a6268;
}

.btn-primary {
  background-color: #0078D4;
  border-color: #0078D4;
  color: white;
}

.btn-primary:hover {
  background-color: #106ebe;
  border-color: #106ebe;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.model-text {
  font-family: Calibre-R;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  vertical-align: middle;
  color: #1A1A1AA6;
  padding: 4px 8px 4px;
  margin-top: 0;
}
</style>